import { Grid, Typography } from '@mui/material';
import React from 'react';
import YesNoInput from '../../YesNoInput';
import { Box } from '@mui/system';

const Questions = ({ control, t }) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: { sm: 'space-between' },
          }}
        >
          <Typography variant="h7" fontWeight={700}>
            {t('question_one')}
          </Typography>
          <YesNoInput control={control} name="receivedInheritance" padding={'0'} notFullWidth questionsForm={true} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: { sm: 'space-between' },
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Typography variant="h7" fontWeight={700}>
            {t('question_two')}
          </Typography>
          <YesNoInput control={control} name="assets" padding={'0'} notFullWidth questionsForm={true} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: { sm: 'space-between' },
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Typography variant="h7" fontWeight={700} sx={{ wordBreak: 'break-word' }}>
            {t('question_three')}
          </Typography>
          <YesNoInput control={control} name="religion" padding={'0'} notFullWidth questionsForm={true} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: { sm: 'space-between' },
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Typography variant="h7" fontWeight={700}>
            {t('question_four')}
          </Typography>
          <YesNoInput control={control} name="taxExtension" padding={'0'} notFullWidth questionsForm={true} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: { sm: 'space-between' },
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Typography variant="h7" fontWeight={700}>
            {t('question_five')}
          </Typography>
          <YesNoInput control={control} name="furtherEducation" padding={'0'} notFullWidth questionsForm={true} />
        </Box>
      </Grid>
    </Grid>
  );
};

export default Questions;
